module.exports = {
      id: "Consumption-usage",
      viewBox: "0 0 22 14",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Consumption-usage",
      toString: function () {
        return this.url;
      }
    }